import { useConfigStore } from '@jwp/ott-common/src/stores/ConfigStore';

export const useAppConfig = () => {
  const { featureFlags, appConfig } = useConfigStore.getState();
  const authentication_type = featureFlags?.common?.authentication_type?.toLowerCase();
  const isCleeng = authentication_type === 'cleeng';
  const isCognitoEnabled = authentication_type === 'cognito';
  const isCustomApiEnabled = authentication_type === 'cognito' || authentication_type === 'custom_backend';

  const isClientActive = featureFlags?.common?.is_client_active ? featureFlags?.platforms?.web?.is_client_active : false;
  const isAuthenticationEnabled = featureFlags?.authentication?.is_authentication_enabled;
  const isQrAuthenticationEnabled = featureFlags?.authentication?.is_qr_authentication_enabled;
  const isFavoriteEnable = featureFlags?.feature_flags?.is_favorite_enabled;
  const isSwitchProfileEnable = featureFlags?.feature_flags?.settings?.is_switch_profile_enabled;
  const isSearchEnabled = featureFlags?.feature_flags?.is_search_enabled;
  const isSocialLoginEnabled = featureFlags?.platforms?.web?.hasOwnProperty('is_social_login_enabled')
    ? featureFlags?.platforms?.web?.is_social_login_enabled
    : featureFlags?.authentication?.is_social_login_enabled;

  const isContinueWatchingEnabled = featureFlags?.feature_flags.is_continue_watching_enabled;
  const byDefaultLanguage = featureFlags?.common.default_language;
  const isEpgEnable = featureFlags?.feature_flags?.is_epg_enabled;
  const isShowLoginButton = featureFlags?.platforms?.web?.hasOwnProperty('can_show_signin_button')
    ? featureFlags.platforms.web.can_show_signin_button
    : featureFlags?.authentication?.can_show_signin_button;

  const isShowRegisterButton = featureFlags?.platforms?.web?.hasOwnProperty('can_show_signup_button')
    ? featureFlags.platforms.web.can_show_signup_button
    : featureFlags?.authentication?.can_show_signup_button;

  const canShowTermsOfUse = featureFlags?.feature_flags?.settings?.is_terms_of_use_enabled;
  const canShowPrivacyPolicy = featureFlags?.feature_flags?.settings?.is_privacy_policy_enabled;
  const canShowExportData = featureFlags?.platforms?.web?.export_account;
  const canDeleteAccount = featureFlags?.platforms?.web?.delete_account;
  const isActivateTV = featureFlags?.platforms?.web?.activate_tv;
  const canChangePassword = featureFlags?.platforms?.web?.change_password;
  const isAnalyticsEnable = featureFlags?.feature_flags?.is_analytics_enabled;
  const isGoogleAnalytics = isAnalyticsEnable ? featureFlags?.feature_flags?.analytics_provider?.google : false;
  const isAdEnabled = featureFlags?.feature_flags?.ad_enabled;
  const isSupportEmail = featureFlags?.feature_flags?.is_support_email;
  const isVideoQualityEnabled = featureFlags?.feature_flags?.settings?.is_video_quality_enabled;
  const isAutoPlay = featureFlags?.platforms?.web?.hasOwnProperty('is_autoplay_enabled')
    ? featureFlags.platforms.web.is_autoplay_enabled
    : featureFlags?.feature_flags?.settings?.is_autoplay_enabled;
  const autoplayDefaultValue = featureFlags?.feature_flags?.settings?.autoplay_default_value;

  const isMultiLanguageSupport = featureFlags?.feature_flags?.is_multi_language_support;
  const canShowSettings = featureFlags?.feature_flags?.settings?.is_settings_enable;
  const isSubscriptionEnabled = featureFlags?.feature_flags?.is_subscription_enabled;
  const isGuestModeEnabled = featureFlags?.authentication?.is_guest_mode_enabled;
  const guestStreamingEnabled = featureFlags?.feature_flags?.guest_streaming_enabled;
  const isCatchUpHoursEnabled = appConfig?.video_details?.epg?.is_catchup_hours_enabled;
  const adobeScripTag = featureFlags?.feature_flags?.settings?.analytics_settings?.abobe?.script_tag;
  const adConfigLevel = featureFlags?.feature_flags?.ad_settings?.ad_config_level;

  // ========= needs to implement ==============
  const isFirebaseAnalytics = isAnalyticsEnable ? featureFlags?.feature_flags?.analytics_provider?.firebase : false;
  const isAppsFlyerAnalytics = isAnalyticsEnable ? featureFlags?.feature_flags?.analytics_provider?.appsflyer : false;
  const isAdobeAnalytics = isAnalyticsEnable ? featureFlags?.feature_flags?.analytics_provider?.adobe : false;
  const isRelatedVideos = featureFlags?.feature_flags.is_recommended_content_enabled;

  // ===========================================

  return {
    isCleeng,
    isCognitoEnabled,
    isCustomApiEnabled,
    isClientActive,
    isAuthenticationEnabled,
    isFavoriteEnable,
    isSwitchProfileEnable,
    isSearchEnabled,
    isSocialLoginEnabled,
    isContinueWatchingEnabled,
    isEpgEnable,
    byDefaultLanguage,
    isShowLoginButton,
    isShowRegisterButton,
    isAnalyticsEnable,
    isGoogleAnalytics,
    isFirebaseAnalytics,
    isAppsFlyerAnalytics,
    isAdobeAnalytics,
    canShowTermsOfUse,
    canShowPrivacyPolicy,
    canShowExportData,
    canDeleteAccount,
    canChangePassword,
    isRelatedVideos,
    isAdEnabled,
    isMultiLanguageSupport,
    isSupportEmail,
    isActivateTV,
    canShowSettings,
    isSubscriptionEnabled,
    isGuestModeEnabled,
    guestStreamingEnabled,
    isCatchUpHoursEnabled,
    isVideoQualityEnabled,
    adobeScripTag,
    adConfigLevel,
    isAutoPlay,
    isQrAuthenticationEnabled,
    autoplayDefaultValue,
  };
};
